import React from "react";

import { Navigate, createFileRoute } from "@tanstack/react-router";

import { Queries } from "@/queries/Queries.ts";
import { PractitionerRootTemplate } from "@/uiKit/templates/PractitionerRootTemplate.tsx";

const PractitionerRouteGuard: React.FC = () => {
  const me = Queries.user.useMe({});
  switch (me.userType) {
    case "practitioner":
      return <PractitionerRootTemplate />;
    default:
      return <Navigate to="/" />;
  }
};
export const Route = createFileRoute("/_practitioner")({
  component: PractitionerRouteGuard,
});
